import React from "react";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Button from "@amzn/meridian/button";

interface PlanSummaryStateProps {
  planId?: string,
  totalOverrides?: number
  onButtonClick: () => void;
  buttonLabel: string;
  disableButton: boolean;
}

/**
 * Plan Summary component
 */
const PlanSummary: React.FC<PlanSummaryStateProps> = ({
  planId,
  totalOverrides,
  onButtonClick,
  buttonLabel,
  disableButton
}) => {

  const onGenerateNewPlan = () => {};

  return (
    <Box className="plan-summary" type="fill" spacingInset="350">
      <Box className="plan-info">
        <Box>
          <Text  type="h100" className="plan-input-text" >Current plan input summary ({totalOverrides} overrides)</Text>
          <Text type="b100" className="plan-input-text">(Plan Id: {planId})</Text>
        </Box>
        <Button onClick={onButtonClick} disabled={disableButton}>
          {buttonLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default PlanSummary;

import './index.scss';